import React from 'react';
import { connect } from 'react-redux';
import {
  Image,
} from 'semantic-ui-react';

const baseUrl = '/dealer/api/images';

const ImageFormatter = (props) => (
  <div style={{ padding: '10px 0' }}>
    <h3
      style={{
        color: !props.url ? 'red' : '',
        marginBottom: 0,
      }}
    >{props.title}</h3>
    {
      props.url
        ? <Image style={{ marginTop: '12px' }} src={props.url} size="large" />
        : <p>Not uploaded!</p>
    }
  </div>
);

const MissingText = () => <p>Missing Image</p>

function Images(props) {
  const {
    coRenter,
    driversLicense,
    proofOfIncome,
    proofOfResidence,
    renter,
    // voidedCheck,
  } = props;

  const renterName = `${renter.first_name} ${renter.last_name}`;
  let coRenterName = '';

  if (coRenter) {
    coRenterName = `${coRenter.first_name} ${coRenter.last_name}`;
  }

  return (
    <div style={{ margin: '30px 0' }}>
      {
        /*
          <ImageFormatter
            title="Voided Check"
            url={voidedCheck ? `${baseUrl}/voided-check/${voidedCheck.filename}` : null}
          />
        */
      }
      <ImageFormatter
        title={`${renterName} Driver's License`}
        url={driversLicense ? `${baseUrl}/drivers-license/${driversLicense.filename}` : null}
      />
      <ImageFormatter
        title={`${renterName} Proof of Income`}
        url={proofOfIncome ? `${baseUrl}/proof-of-income/${proofOfIncome.filename}` : null}
      />
      <ImageFormatter
        title={`${renterName} Current Mortgage Statement`}
        url={proofOfResidence ? `${baseUrl}/proof-of-residence/${proofOfResidence.filename}` : null}
      />
      {
        coRenter &&
          <React.Fragment>
            <ImageFormatter
              title={`${coRenterName} Driver's License`}
              image={coRenter.drivers_license_image}
              url={coRenter.drivers_license_image ? `${baseUrl}/drivers-license/${coRenter.drivers_license_image.filename}` : null}
            />
            <ImageFormatter
              title={`${coRenterName} Proof of Income`}
              image={coRenter.proof_of_income_image}
              url={coRenter.proof_of_income_image ? `${baseUrl}/proof-of-income/${coRenter.proof_of_income_image.filename}` : null}
            />
            <ImageFormatter
              title={`${coRenterName} Current Mortgage Statement`}
              image={coRenter.proof_of_residence_image}
              url={coRenter.proof_of_residence_image ? `${baseUrl}/proof-of-residence/${coRenter.proof_of_residence_image.filename}` : null}
            />
          </React.Fragment>
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    coRenter: state.coRenter,
    driversLicense: state.driversLicense,
    proofOfIncome: state.proofOfIncome,
    proofOfResidence: state.proofOfResidence,
    renter: state.renter,
    // voidedCheck: state.voidedCheck,
  }
}

export default connect(mapStateToProps)(Images);
